<ng-container *ngIf="!cartItems || cartItems.length === 0; else filledCart">
  <div class="min-h-[55vh] flex flex-col justify-center items-center px-4 py-12">
    <div
      class="flex items-center justify-center rounded-full h-14 w-14 bg-zestNeutral-200 p-2 mb-[9px]"
    >
      <img src="../../../assets/svg/Bag.svg" alt="empty cart" />
    </div>
    <div class="md:max-w-[332px] w-full text-center">
      <h5 class="mt-1 mb-[9px] lg:mt-0 text-zestBlack text-lg font-medium">
        Your cart is empty.
      </h5>
      <p class="text-zestTertiary-500 text-sm font-normal tracking-wide">
        You don't have any item on your cart yet, click on the button below to
        shop.
      </p>
    </div>
    <button
      [routerLink]="['/stores', storeName | lowercase]"
      class="text-zestWhite bg-zestBlack border-[#80909D] border text-sm lg:text-base rounded-lg py-4 px-8 mt-8 w-full md:w-2/5"
    >
      Continue Shopping
    </button>
  </div>
</ng-container>

<ng-template #filledCart>
  <div class="px-0 py-0 my-0 flex justify-center items-center rounded grow w-full">
    <div class="bg-white grow lg:mr-0 xl:mr-6 pb-[4rem] px-2">

      <h2
        *ngIf="open === 0"
        class="hidden lg:block text-zestBlack font-semibold text-[16px] md:text-2xl ml-8 pt-10 mb-4 pb-6"
      >
        My Cart
      </h2>
      <h2
        *ngIf="open === 3"
        class="hidden lg:block text-zestBlack font-semibold text-2xl ml-8 pt-10 pb-6 border-b"
      >
        Summary
      </h2>

      <div
        class="flex justify-between items-center py-8 mt-4 lg:mt-0 mx-0 lg:py-8 lg:mx-8 border-b border-zestNeutral last:border-b-0"
        *ngFor="let cartItem of cartItems"
      >
        <div class="flex justify-start items-center px-0">
          <img
            src="{{ cartItem?.product.image_data[0]?.image_source }}"
            alt="cart-product"
            class="mr-4 w-20 h-20 rounded"
          />
          <div>
            <h4
              class="font-normal text-sm text-zestLabel lg:font-medium lg:text-base lg:text-zestBlack lg:w-44"
            >
              {{ cartItem?.product.product_name }}
              <span
                class="text-xs text-zestPlaceholder"
                *ngIf="cartItem?.purchasedvariant"
                >({{ cartItem?.purchasedvariant }})</span
              >
            </h4>

            <!-- Mobile price -->
            <small
              *ngIf="cartItem.purchasedPrice; else mobileDiscount"
              class="block text-xs pt-1 text-zestBlack lg:hidden font-medium"
            >
              {{ cartItem?.purchasedPrice * cartItem?.cartQuantity | currency : "₦ " }}
            </small>
            <ng-template #mobileDiscount>
              <small class="block text-xs pt-1 text-zestBlack lg:hidden font-medium">
                {{
                  cartItem?.product.discounted_price && cartItem?.product.discounted_price !== 0
                    ? (cartItem?.product.discounted_price * cartItem?.cartQuantity | currency : "₦ ")
                    : (cartItem?.product.price * cartItem?.cartQuantity | currency : "₦ ")
                }}
              </small>
            </ng-template>

            <!-- Mobile quantity controls -->
            <div class="flex justify-between items-center lg:hidden">
              <div class="flex justify-between items-center bg-white border-[#F4F6F9] rounded mt-3">
                <button
                  (click)="
                    cartItem.product.productVariant
                      ? minus(cartItem, cartItem.variantPurchased)
                      : store.subtractCartItem(cartItem)
                  "
                  [disabled]="
                    store.getItemCount(cartItem?.product.product_code) === 0 ||
                    store.getVariantCount(cartItem.variantPurchased) === 0
                  "
                  [ngClass]="{ invisible: open === 3 }"
                  class="w-8 h-8 border border-[#F4F6F9] focus:border-zestGreen bg-[#F4F6F9] focus:ring-zestGreen rounded-[2px] text-lg"
                >
                  -
                </button>
                <p class="px-4" *ngIf="!cartItem.product.productVariant">
                  {{ store.getItemCount(cartItem.product.product_code) }}
                </p>
                <p class="px-4" *ngIf="cartItem.product.productVariant">
                  {{ store.getVariantCount(cartItem.variantPurchased) }}
                </p>
                <button
                  [disabled]="store.qunatityExceeded"
                  (click)="
                    cartItem.product.productVariant
                      ? plus(cartItem, cartItem.purchasedvariant, cartItem.purchasedPrice)
                      : store.addCartItem(cartItem)
                  "
                  [ngClass]="{ invisible: open === 3 }"
                  class="w-8 h-8 border border-[#F4F6F9] focus:border-zestGreen bg-[#F4F6F9] focus:ring-zestGreen rounded-[2px] text-lg"
                >
                  +
                </button>
              </div>
            </div>

            <!-- Desktop remove -->
            <div
              (click)="
                cartItem.product.productVariant
                  ? store.removeVariantCartItem(cartItem.variantPurchased)
                  : store.removeCartItem(cartItem.product.product_code)
              "
              *ngIf="open !== 3"
              class="hidden lg:flex items-center pt-3 text-[#4F499F] cursor-pointer"
            >
              <img src="../../../assets/svg/Delete.svg" alt="" class="w-3 mr-2" />
              <p class="text-sm">Remove Item</p>
            </div>
          </div>
        </div>

        <!-- Mobile remove icon -->
        <div
          class="flex items-end self-end lg:hidden pt-5 text-[#4F499F]"
          (click)="
            cartItem.product.productVariant
              ? store.removeVariantCartItem(cartItem.variantPurchased)
              : store.removeCartItem(cartItem.product.product_code)
          "
        >
          <img src="../../../assets/svg/Delete.svg" alt="" class="w-3 ml-8" />
        </div>

        <!-- Desktop quantity controls -->
        <div class="hidden lg:block border border-zestNeutral">
          <div class="flex justify-between items-center bg-white rounded m-2">
            <button
              (click)="
                cartItem.product.productVariant
                  ? minus(cartItem, cartItem.variantPurchased)
                  : store.subtractCartItem(cartItem)
              "
              [disabled]="store.getItemCount(cartItem?.product.product_code) === 0"
              [ngClass]="{ invisible: open === 3 }"
              class="w-8 h-8 border border-zestNeutral focus:border-zestGreen bg-zestNeutral focus:ring-zestGreen rounded-[2px] text-xl"
            >
              -
            </button>
            <p class="px-4">
              {{
                cartItem?.variantPurchased
                  ? store.getVariantCount(cartItem.variantPurchased)
                  : store.getItemCount(cartItem.product.product_code)
              }}
            </p>
            <button
              (click)="
                cartItem.product.productVariant
                  ? plus(cartItem, cartItem.purchasedvariant, cartItem.purchasedPrice)
                  : store.addCartItem(cartItem)
              "
              [ngClass]="{ invisible: open === 3 }"
              class="w-8 h-8 border border-zestNeutral focus:border-zestGreen disabled:text-ZTN-300 bg-zestNeutral focus:ring-zestGreen rounded-[2px] text-xl"
            >
              +
            </button>
          </div>
        </div>

        <!-- Desktop price -->
        <div class="hidden lg:block text-right" *ngIf="cartItem.purchasedPrice; else discounted">
          <p class="text-zestBlack text-lg text-right font-semibold">
            {{ cartItem?.purchasedPrice * cartItem?.cartQuantity | currency : "₦ " }}
          </p>
          <small class="text-sm text-right font-normal text-zestLabel">
            {{ cartItem?.purchasedPrice | currency : "₦ " }} * {{ cartItem?.cartQuantity }}
          </small>
        </div>
        <ng-template #discounted>
          <div class="hidden lg:block text-right">
            <p class="text-zestBlack text-lg text-right font-semibold">
              {{
                cartItem?.product.discount > 0
                  ? (cartItem?.product.discounted_price * cartItem?.cartQuantity | currency : "₦ ")
                  : (cartItem?.product.price * cartItem?.cartQuantity | currency : "₦ ")
              }}
            </p>
            <small class="text-sm text-right font-normal text-zestLabel">
              {{
                cartItem?.product?.discount > 0
                  ? (cartItem?.product.discounted_price | currency : "₦ ")
                  : (cartItem?.product.price | currency : "₦ ")
              }}
              * {{ cartItem?.cartQuantity }}
            </small>
          </div>
        </ng-template>
      </div>

    </div>
  </div>
</ng-template>

<!-- ── Mobile standalone cart view ── -->
<section
  appScrollToTop
  [ngClass]="{ hidden: store.showMobile }"
  class="font-mont lg:bg-[#FBFBFB]"
  *ngIf="!store.isCartShown() && pageLoad"
>
  <app-header
    class="hidden lg:block"
    [storeName]="stores"
  ></app-header>

  <div
    class="px-6 py-4 lg:py-0 flex items-center lg:mx-40 lg:px-0 justify-between shadow-md lg:shadow-none lg:justify-start"
    (click)="onBackClick()"
  >
    <img src="../../../assets/svg/back.svg" alt="back" class="cursor-pointer" />
    <p class="hidden lg:block font-medium text-zestBlack text-lg font-mont px-4 py-6">Back</p>
    <h5 class="text-zestBlack block lg:hidden font-semibold text-2xl">My Cart</h5>
    <p class="block lg:hidden text-2xl">&nbsp;</p>
  </div>

  <main class="block mx-6 xl:flex lg:mx-40">
    <div class="px-0 py-0 my-0 rounded xl:pr-6 grow w-full xl:w-8/12">
      <div class="bg-white grow lg:mr-0 xl:mr-6">
        <p class="hidden lg:block text-zestBlack font-semibold text-2xl ml-8 py-7">My Cart</p>

        <!-- Mobile standalone empty state -->
        <ng-container *ngIf="!cartItems || cartItems.length === 0">
          <div class="flex flex-col items-center py-12">
            <div
              class="flex items-center justify-center rounded-full h-14 w-14 bg-zestNeutral-200 p-2 mb-[9px]"
            >
              <img src="../../../assets/svg/Bag.svg" alt="empty cart" />
            </div>
            <div class="md:max-w-[332px] w-full text-center">
              <h5 class="mt-1 mb-[9px] text-zestBlack text-lg font-medium">Your cart is empty.</h5>
              <p class="text-zestTertiary-500 text-sm font-normal tracking-wide">
                You don't have any items in your cart yet.
              </p>
            </div>
            <button
              [routerLink]="['/stores', storeName | lowercase]"
              class="text-zestWhite bg-zestBlack border-[#80909D] border text-sm lg:text-base rounded-lg py-4 px-8 mt-8 w-full md:w-2/5"
            >
              Continue Shopping
            </button>
          </div>
        </ng-container>

        <!-- Mobile standalone filled cart -->
        <div
          class="flex justify-between items-center py-8 mt-4 lg:mt-0 mx-0 lg:py-8 lg:mx-8"
          *ngFor="let cartItem of cartItems"
        >
          <div class="flex justify-start items-center px-0">
            <img
              src="{{ cartItem?.product.image_data[0]?.image_source }}"
              alt="cart-product"
              class="mr-4 w-20 h-20 rounded"
            />
            <div>
              <p
                class="font-normal text-sm text-zestLabel lg:font-medium lg:text-base lg:text-zestBlack lg:w-44"
              >
                {{ cartItem?.product?.product_name }}
                <span
                  class="text-xs text-zestPlaceholder"
                  *ngIf="cartItem?.purchasedvariant"
                  >({{ cartItem?.purchasedvariant }})</span
                >
              </p>
              <small
                *ngIf="cartItem?.purchasedPrice; else mobileStandaloneDiscount"
                class="block text-xs pt-1 text-zestBlack lg:hidden font-medium"
              >
                {{ cartItem?.purchasedPrice * cartItem?.cartQuantity | currency : "₦ " }}
              </small>
              <ng-template #mobileStandaloneDiscount>
                <small class="block text-xs pt-1 text-zestBlack lg:hidden font-medium">
                  {{
                    cartItem?.product?.discount > 0
                      ? (cartItem?.product?.discounted_price * cartItem?.cartQuantity | currency : "₦ ")
                      : (cartItem?.product?.price * cartItem?.cartQuantity | currency : "₦ ")
                  }}
                </small>
              </ng-template>
            </div>
          </div>
        </div>

      </div>
    </div>
  </main>
</section>
